export const INVITE_EXHIBITOR_BY_FORM = `
  mutation inviteExhibitorByForm($input: InviteExhibitorByFormInput!, $tenant_id: Int!) {
    inviteExhibitorByForm(input: $input, tenant_id: $tenant_id) {
      __typename
      ... on Exhibitor {
        id
        contact_id
        status
        type
        contact {
          id
          firstname
          lastname
          email
        }
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const SUBMIT_EXHIBITOR_FORM = `
  mutation submitExhibitorForm(
    $token: String!
    $contactInput: SubmitContactFormInput!
    $exhibitorInput: SubmitExhibitorFormInput!
  ) {
    submitExhibitorForm(
      token: $token
      contactInput: $contactInput
      exhibitorInput: $exhibitorInput
    ) {
      __typename
      ... on BooleanResult {
        result
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const UPLOAD_EXHIBITOR_FORM_PROFILE_PICTURE = `
  mutation uploadExhibitorFormProfilePicture($token: String!, $file: Upload!) {
    uploadExhibitorFormProfilePicture(token: $token, file: $file) {
      id
      url
    }
  }
`;
